import React from 'react';
import { Lock, QrCode, FileCode, Link, Braces, Hash, Palette, Clock, TestTube, Shield } from 'lucide-react';
import { ToolCard } from '../components/ToolCard';
const tools = [{
  title: 'Password Generator',
  description: 'Generate secure random passwords',
  icon: Lock,
  href: '/developer/password-generator'
}, {
  title: 'QR Code Generator',
  description: 'Create QR codes from text or URLs',
  icon: QrCode,
  href: '/developer/qr-generator'
}, {
  title: 'Base64 Encoder/Decoder',
  description: 'Encode and decode Base64 data',
  icon: FileCode,
  href: '/developer/base64'
}, {
  title: 'URL Encoder/Decoder',
  description: 'Encode and decode URLs',
  icon: Link,
  href: '/developer/url-encoder'
}, {
  title: 'JSON Formatter',
  description: 'Format and validate JSON data',
  icon: Braces,
  href: '/developer/json-formatter'
}, {
  title: 'UUID Generator',
  description: 'Generate unique identifiers',
  icon: Hash,
  href: '/developer/uuid-generator'
}, {
  title: 'Color Picker & Converter',
  description: 'Convert between HEX, RGB, and HSL',
  icon: Palette,
  href: '/developer/color-converter'
}, {
  title: 'Unix Timestamp Converter',
  description: 'Convert Unix timestamps to dates',
  icon: Clock,
  href: '/developer/timestamp'
}, {
  title: 'Regex Tester',
  description: 'Test regular expressions',
  icon: TestTube,
  href: '/developer/regex-tester'
}, {
  title: 'Hash Generator',
  description: 'Generate MD5 and SHA hashes',
  icon: Shield,
  href: '/developer/hash-generator'
}];
export function DeveloperPage() {
  return <div className="container mx-auto px-4 py-8" data-id="element-199">
      <div className="mb-8" data-id="element-200">
        <h1 className="text-4xl font-bold mb-2" data-id="element-201">Developer Tools</h1>
        <p className="text-muted-foreground" data-id="element-202">
          Essential utilities for developers and technical users
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-203">
        {tools.map(tool => <ToolCard key={tool.href} {...tool} data-id="element-204" />)}
      </div>
    </div>;
}